const ErrorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4.25C24.0422 4.25 29.75 9.95775 29.75 17C29.75 24.0422 24.0422 29.75 17 29.75C9.95775 29.75 4.25 24.0422 4.25 17C4.25 9.95775 9.95775 4.25 17 4.25Z"
        fill="#F9302C"
      />
      <path
        d="M16.9999 10.6257V17.709"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0013 23.3743C17.1968 23.3743 17.3555 23.2157 17.3541 23.0202C17.3541 22.8247 17.1954 22.666 16.9999 22.666C16.8044 22.666 16.6457 22.8247 16.6457 23.0202C16.6457 23.2157 16.8044 23.3743 17.0013 23.3743"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ErrorIcon;
